<template>
<div>
<b-container v-if="infopoint">
    <b-row>
        <b-col sm="3" class="text-sm-right"><b>SSH:</b></b-col>
        <b-col>{{ infopoint.status.ssh }}</b-col>
    </b-row>
    <b-row>
        <b-col sm="3" class="text-sm-right"><b>Uptime:</b></b-col>
        <b-col>{{ infopoint.status.upTime }}</b-col>
    </b-row>
    <b-row>
        <b-col sm="3" class="text-sm-right"><b>Disk Usage:</b></b-col>
        <b-col>{{ infopoint.status.diskUsage }}</b-col>
    </b-row>
    <b-row>
        <b-col sm="3" class="text-sm-right"><b>Viewer:</b></b-col>
        <b-col>{{ infopoint.status.applicationVersion }}</b-col>
    </b-row>
    <b-row>
        <b-col sm="3" class="text-sm-right"><b>Controller:</b></b-col>
        <b-col>{{ infopoint.status.controllerVersion }}</b-col>
    </b-row>
    <b-row>
        <b-col sm="3" class="text-sm-right"><b>Scripts:</b></b-col>
        <b-col>{{ infopoint.status.scriptVersion }}</b-col>
    </b-row>
    <b-row>
        <b-col sm="3" class="text-sm-right"><b>IP:</b></b-col>
        <b-col>{{ infopoint.status.ip }}</b-col>
    </b-row>
    <b-row>
        <b-col sm="3" class="text-sm-right"><b>Traveller:</b></b-col>
        <b-col>{{ infopoint.status.departureCount }} {{ infopoint.status.firstDepartureTime }} - {{ infopoint.status.lastDepartureTime }}</b-col>
    </b-row>
    <b-row>
        <b-col sm="3" class="text-sm-right"><b>Playlists:</b></b-col>
        <b-col>{{ infopoint.status.playlistInfo }}</b-col>
    </b-row>    
</b-container>

</div>
</template>

<script>

export default {
    props: ['infopoint']
    /*
    computed: {
        infopoint() {
            return this.$store.state.infopoint.selectedInfopoint;
        }
    }
    */
}

</script>

<style scoped lang="scss">
.row {
    font-size: 0.75rem;
    white-space: pre-wrap;
}
</style>
